import { React, Styled } from '@common/3rd';
import { DeskPage, DeskPageBody } from '@desk-component';
import { PageComponents, DeskPageBodyComponents, ButtonType } from '@my-types';
import { DeskButton, DeskImage } from '@desk-component';
import { orderType } from '../const';
import { Apis, Ajax, Envs, Utils } from '@common';
import { StyledComponents } from '@styles';
import { ModelWidget } from '@component';
import close from '@images/mej/close2x.png';



class VendorCade<P extends {
	vendorList: any[];
	query: Function;
}, S extends {
	codes: string[];
	show: boolean;
}, C extends {
	Wrapper: any;
	VendorBody: any;
	VendorBackDrop: any;
}> extends ModelWidget<P, S, C>{

	constructor(props: any, context?: any) {
		super(props, context);
	}

	componentDidMount(): void {
		this.setState({
			show: false,
		}, () => {
			if (this.state.show === true) {
				// Envs.application()!.setScrollDisabled(true);
			} else {
				// Envs.application()!.setScrollDisabled(false);
			}
		})
	}

	protected initComponents(): C {
		return {
			Wrapper: Styled.div.attrs({
				'data-widget': 'vendorCade-wrapper'
			})`
                display:flex;
                flex-direction: column;
                align-items: flex-start;
                z-index: 2;

				> div:nth-child(1){
					min-width: 85px;
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 40px;
				}
            `,
			VendorBody: Styled.div.attrs({
				'data-widget': 'vendor-body'
			})`

				z-index: 2;
				border-radius: 6px;
                &[data-show=true]{
                    display:flex;
                }
                &[data-show=false]{
                    display:none;
                }

                height: 300px;
                position: absolute;
                width: 400px;
                background: #fff ;
                word-break: break-word;
                flex-direction: column;
                justify-content: flex-start;
                background: #fff;
                padding: 5px 16px;
                margin-top: 40px;

				// transform: translate3d(-80% ,0px,0px);

                > div:nth-child(1){
					font-family: PingFangSC;
					color: #000000;
					font-weight: 600;
					font-size: 14px;
					font-style: normal;
					text-decoration: none;
					text-align: left;
					display: flex;
                    width:100%;
					align-items: center;
    				justify-content: space-between;
					> .close{
						justify-content: center;
						margin-top: 5px;
						width: 20px;
						height: 20px;
						background:url(${close});
						background-repeat: no-repeat;
						background-size:90%;
					}
                }
                > div:nth-child(2){
                    display: flex;
                    overflow-y: scroll;
                    flex-wrap: wrap;
					align-content: flex-start;
                    // grid-column-gap: 8px;
                    // grid-row-gap: 8px;
                    min-height: 180px;
					overflow:auto;
                    > div {
                        background:#F6F7FB;

						border-radius: 6px;
                        padding-left:11px;
						padding-right:11px;
                        margin-right:10px;
						margin-bottom:10px;

                        font-family: PingFangSC;
                        color: #818498;
                        font-weight: 400px;
                        font-size: 12px;
                        font-style: normal;
                        text-decoration: none;
                        text-align: left;
                        height:27px;
                        align-items: center;
                        display: flex;                    

                        &.active {
							background: ${props => props.theme.COLOR_SUCCESS};
							color: #fff;
                        }
                    }
                }

                > div:nth-child(3){
                    padding: 0 16px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    // grid-column-gap: 16px;
					margin-top:10px;
					padding-bottom:20px;
                    > div{
						height:36px;
                        border-radius: 18px;
                        display: flex;
						align-items:center;
						width:140px;
						margin:0 auto;
                        justify-content: center;
                        border:0.5px solid #E3E4E9;
                    }

                    > div:nth-child(2){
                        color:#fff;
                        background:${props => props.theme.COLOR_SUCCESS};
                    }
                }

            `,
			VendorBackDrop: Styled.div.attrs({
				'data-widget': 'vendor-back-drop'
			})`
				&[data-show=true]{
					display:flex;
				}
				&[data-show=false]{
					display:none;
				}
				background: #000;
				position: absolute;
				top: 0;
				left: 0;
				height: -webkit-fill-available;
				width: 100vw;
				opacity: 0.1;
			`
		} as C;
	}

	renderVendorPanel() {
		const { VendorBody } = this.getComponents();
		return <VendorBody data-show={this.state.show}>
			<div>保险公司
				<div className='close' onClick={() => {
					this.setState({
						show: false,
					});
				}}></div>
			</div>
			<div>
				{this.props.vendorList.map((item, index) => {
					return <div key={index}
						className={this.state.codes?.includes(item.code) ? 'active' : ''}
						onClick={() => {
							const codes = this.state.codes || [];
							const index = codes.findIndex((it: any) => it == item.code);
							if (index !== -1) {
								codes.splice(index, 1);
							} else {
								codes.push(item.code);
							}
							this.setState({
								codes
							})
						}}>
						{`${item.name}`}
					</div>
				})}
			</div>
			<div>
				<div onClick={() => {
					this.setState({
						codes: []
					})
				}}>重置</div>
				<div onClick={() => {
					//查询
					this.setState({
						show: false,
					}, () => {
						if (this.state.show === true) {
							// Envs.application()!.setScrollDisabled(true);
						} else {
							// Envs.application()!.setScrollDisabled(false);
						}
						console.log(this.state.codes);
                        const query = this.props.query;
                        query(this.state.codes);
					})
				}}>确定</div>
			</div>
		</VendorBody>
	}

	render(): JSX.Element {
		const { Wrapper, VendorBackDrop } = this.getComponents();
		return <Wrapper >
			<div onClick={() => {
				const show = this.state.show;
				this.setState({
					show: !show
				}, () => {
					if (this.state.show === true) {
						// Envs.application()!.setScrollDisabled(true);
					} else {
						// Envs.application()!.setScrollDisabled(false);
					}
				})
			}}>筛选{this.state.show === true ? <StyledComponents.FAS icon="caret-up" /> : <StyledComponents.FAS icon="caret-down" />}</div>
			{this.renderVendorPanel()}
			<VendorBackDrop data-show={this.state.show} onClick={()=>{
				this.setState({
					show: false,
				})
			}} />
		</Wrapper>
	}

}
class Product extends DeskPage<any, any, PageComponents & DeskPageBodyComponents> {
	constructor(props: any) {
		super(props);
		this.state = {
			coverage: '',
			order: '',
			salesRankList: [],
			productList: [],
			coverageType: [],
			vendorTypeList: [],
			orderType: orderType,
			priceOrder: '',
			targetGroup: '',
			vendorList: [],
		}
	}
	async queryProductList(options?: { tagName?: string, targetGroup?: string, vendorList?: any[] }) {
		const { tagName = this.state.coverage, targetGroup = this.state.targetGroup, vendorList = this.state.vendorList } = options || {}; 
		try {
			let path = Apis.QUERY_PRODUCT_LIST + '?pageSize=999';
			let queryParams: { [propName: string]: any } = {
				tagName: tagName || '',
				keyword: '',
				salesType: '2',
				targetGroup: !Utils.isBlank(targetGroup) ? targetGroup : null,
                vendorList
			};
			if (!Ajax.isAuthorized()) {
				queryParams.tenantCode = this.tenantCode;
			}
			if (this.state.priceOrder) {
				queryParams.orderByPrice = this.state.priceOrder; // 'DESC' 'ASC'
			}
			let res = await this.getHelpers().getAjax().post(path, queryParams, { loading: true });
			// console.log('product list res', res);
			if (res?.body?.body?.items) {
				if (Utils.isBlank(tagName) && Utils.isBlank(targetGroup) && Utils.toArray(vendorList).length === 0) { // 查询全部时，更新产品tag列表
					let coverageType = this.getProductTags(res.body.body.items);
					let vendorTypeList = this.getVendorNameTags(res.body.body.items);
					this.setState({
						coverageType: coverageType,
						vendorTypeList
					});
				}
				this.setState({
					productList: (res.body.body.items as any[]).map(item => {
						item.showOverall = false;
						item.qrcode = '';
						return item;
					})
				});
			}
		} catch (e) {
			console.log('query product list error', e);
		}
	}
	async componentDidMount() {
		super.componentDidMount();
		try {
			const account = Envs.findAccount();
			let params: { [propName: string]: any } = {
				tenantCode: account.tenantCode || this.tenantCode,
				configType: "SALES_CONFIG", // 不在使用数字"3",使用英文字母组合
				status: 1
			};
			let configRes = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, params, { loading: true });
			if (configRes?.body?.body && configRes.body.body.length) {
				let configList: { [propName: string]: any }[] = configRes.body.body;
				// TODO: terminal为2或3，type为2暂无数据，先以移动端数据调试
				let saleRankObj = Utils.getConfigFromRes(configList, { detailConfigType: '2' });
				this.setState({
					salesRankList: saleRankObj.list
				});
			}
			this.queryProductList();
		} catch (e) {
			console.log('load product list error', e);
		}
	}
	closeAllMouseOver() {
		if (this.state.salesRankList?.length) {
			(this.state.salesRankList as any[]).forEach(i => {
				this.handleMouseLeave(i, 'salesRankList');
			});
		}
		if (this.state.productList?.length) {
			(this.state.productList as any[]).forEach(i => {
				this.handleMouseLeave(i, 'productList');
			})
		}
	}
	renderPageBody() {
		const C = this.getComponents();
		return <DeskPageBody where="保险产品" tenantCode={this.tenantCode} vendor={this.props?.vendor}>
			<C.ContentWrapper css={() => `
			border-bottom: 1px solid #ededed;
			margin-bottom: 40px;
			padding-bottom: 10px;
			[data-widget='product-rank'] {
                > div:first-child {
                    padding: 20px;
                }
            }`}>
				<div></div>
				{(this.state.salesRankList as any[]).map((item, index) => {
					return <C.Rank key={`sale_${index}`} onClick={() => {
						if (item.qrcode) {
							this.handleMouseLeave(item, 'salesRankList');
						} else {
							this.closeAllMouseOver();
							this.handleMouseOver(item, 'salesRankList');
						}
					}}>
						<C.Overall className={item.showOverall ? 'show' : ''}>
							<div>
								{item.qrcode ? <img className="qrcode" src={item.qrcode} alt="" /> : null}
								<p>手机扫码至移动端查看详情</p>
							</div>
						</C.Overall>
						<div>
							<span title={item?.productInfo?.advertisementName}>{item?.productInfo?.advertisementName}</span>
							<div className="item-desc">
								{item?.productInfo?.slogan1}
								{item?.productInfo?.slogan2 ? ` | ${item?.productInfo?.slogan2}` : null}
								{item?.productInfo?.slogan3 ? ` | ${item?.productInfo?.slogan3}` : null}
							</div>
							<div className="item-premium">
								<C.Premium css={(props) => `color: ${props.theme.COLOR_PRIMARY};>span:first-child{font-size: 32px;font-weight:500;}span:not(:first-child){font-size: 16px;}`}>
									<span>{item?.productInfo?.minPrice?.toLocaleString()}</span><span>元起</span>
								</C.Premium>
								<DeskButton type={ButtonType.PRIMARY} css={() => ``}>
									查看详情
								</DeskButton>
							</div>
						</div>
					</C.Rank>
				})}
			</C.ContentWrapper>
			<C.ContentWrapper>
				<C.Classification>
					<div className="not-button">按险种:&nbsp;&nbsp;</div>
					{(this.state.coverageType as any[]).map((item, index) => <div key={`coverage_${index}`}
						className={this.state.coverage === item.code ? 'active' : ''}
						onClick={() => {
							this.setState({
								coverage: item.code
							});
							this.queryProductList({ tagName: item.code });
						}}
					>
						<div>{item.name}</div>
					</div>)}
				</C.Classification>
				<C.TargetGroupClassification>
					<div>
						<div>为谁买:&nbsp;&nbsp;</div>
						{([{ code: '', name: '不限' }, { code: '1', name: '成人' }, { code: '2', name: '老人' }, { code: '3', name: '少儿' }, { code: '99', name: '其他' }] as any[]).map((item, index) => <div key={`targetGroup_${index}`}
							className={this.state.targetGroup === item.code ? 'active' : ''}
							onClick={() => {
								this.setState({
									targetGroup: item.code
								});
								this.queryProductList({ targetGroup: item.code });
							}}
						><div>{item.name}</div></div>)}
					</div>
					<VendorCade vendorList={this.state.vendorTypeList} query={(codes: []) => {
                        this.setState({
                            vendorList: codes
                        }, () => {
                            this.queryProductList({ vendorList: codes })
                        });
                    }} />
				</C.TargetGroupClassification>
				{/* <C.Classification>
					{(this.state.orderType as any[]).map((item, index) => <div key={`order_${index}`}
						className={item.code === this.state.order ? 'active' : ''}
						onClick={() => {
							this.setState({
								order: item.code
							});
							if (item.code === 'price') {
								this.setState({
									priceOrder: this.state.priceOrder !== 'ASC' ? 'ASC' : 'DESC'
								}, () => {
									this.queryProductList({ tagName: this.state.coverage, targetGroup: this.state.targetGroup, vendorList: this.state.vendorList });
								});
							} else if (!item.code) {
								this.setState({
									priceOrder: ''
								}, () => {
									this.queryProductList({ tagName: this.state.coverage, targetGroup: this.state.targetGroup, vendorList: this.state.vendorList });
								});
							}
						}}
					>
						{item.name}
						{item.code === 'price' ? <>
							&nbsp;&nbsp;
							<StyledComponents.FAS className={this.state.priceOrder === 'ASC' ? 'active' : ''} icon="caret-up" />
							<StyledComponents.FAS className={this.state.priceOrder === 'DESC' ? 'active' : ''} icon="caret-down" />
						</> : null}
					</div>)}
				</C.Classification> */}
			</C.ContentWrapper>
			{ Utils.toArray(this.state.productList).length != 0 ?
			<C.ContentWrapper>
				<div></div>
				{(this.state.productList as any[]).map((item, index) => {
					return <C.Product key={`ent_${index}`} onClick={() => {
						if (item.qrcode) {
							this.handleMouseLeave(item, 'productList');
						} else {
							this.closeAllMouseOver();
							this.handleMouseOver(item, 'productList', true);
						}
					}}>
						<div>
							<C.Overall className={item.showOverall ? 'show' : ''}>
								<div>
									{item.qrcode ? <img className="qrcode" src={item.qrcode} alt="" /> : null}
									<p>手机扫码至移动端查看详情</p>
								</div>
							</C.Overall>
							<DeskImage src={item?.cardImage1} alt="" css={() => `width: 100%;`} />
							{/* {item.exclusive ? <C.SupTip>专属</C.SupTip>: null}    */}
						</div>
						<div>
							<div className="item-title" title={item.advertisementName}>{item.advertisementName}</div>
							{item?.vendorName ? <div className="item-vendor">{item?.vendorName}</div> : null}
							<div className="item-desc">
								{item?.slogan1 ? <p>{item?.slogan1}</p> : null}
								{item?.slogan2 ? <p>{item?.slogan2}</p> : null}
								{item?.slogan3 ? <p>{item?.slogan3}</p> : null}
							</div>
							<div className="item-premium">
								<C.Premium>
									<span>{item?.minPrice?.toLocaleString()}</span><span>元起</span>
								</C.Premium>
								<DeskButton type={ButtonType.PRIMARY} css={() => `padding: 5px 20px;`}>
									查看详情
								</DeskButton>
							</div>
						</div>
					</C.Product>
				})}
			</C.ContentWrapper>
				: <C.ContentWrapper css={() => `margin-top: 20px!important;`}><span>未查询到相关内容</span></C.ContentWrapper>}
		</DeskPageBody>
	}
}
export default Product;

export {VendorCade}